/* eslint-disable jira/i18n/id-named-by-package */
import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'eoc-changeboarding.wizard.steps.three.title-no-translate',
		defaultMessage: 'What happens to chat tools',
		description: 'Title of step three',
	},
	description: {
		id: 'eoc-changeboarding.wizard.steps.three.description-no-translate',
		defaultMessage:
			'Connect your chat tools and copy your Opsgenie chat integrations to Jira Service Management, as they won’t be shifted automatically.',
		description: 'Description of step three',
	},
	chatIntegrationsFoundInOpsgenie: {
		id: 'eoc-changeboarding.wizard.steps.three.chat-integrations-found-in-opsgenie-no-translate',
		defaultMessage:
			'{amount, plural, one {{amount} Opsgenie chat integration} other {{amount} Opsgenie chat integrations}} found',
		description: 'The indicator that shows how many chat integrations found in Opsgenie',
	},
	integration: {
		id: 'eoc-changeboarding.wizard.steps.three.integration-no-translate',
		defaultMessage: 'Integration',
		description: 'Table header that indicates integration name',
	},
	team: {
		id: 'eoc-changeboarding.wizard.steps.three.team-no-translate',
		defaultMessage: 'Team',
		description: 'Table header that indicates team name',
	},
	global: {
		id: 'eoc-changeboarding.wizard.steps.three.global-no-translate',
		defaultMessage: 'Global',
		description: 'The name of the global team',
	},
});
